import angular from 'angular';
import userTemplateIcon from './icon/userTemplateIcon';
import usersTemplates from './usersTemplates';
import './style.scss';

export default angular
  .module('components.usersTemplates', [])
  .component('userTemplateIcon', userTemplateIcon)
  .component('usersTemplates', usersTemplates).name;
